import { createSlice } from "@reduxjs/toolkit";

// createing reducer with intial value
export const terminalReducer = createSlice({
  name: "terminal_store",
  initialState: {
    isAuthenticated: false,
    switchTerminalView: false,
    registerData: {},
    registerClosure: null,
    lastRegisterClosure: null,
    on_holded_sales: [],
    inventoryPOS: {
      contentType: "",
      sales_reciept: "",
      cart: [],
      products: [],
      customers: [],
      brands: [],
      discount: {},
      shipping: {},
    },
    itemsSoldCount: 0,
    acceptReturn: {},
  },
  reducers: {
    updateProductsFromSocket: (state, action) => {
      const updatedProducts = action.payload;

      if (!Array.isArray(updatedProducts)) {
        return;
      }

      updatedProducts.forEach((updatedProduct) => {
        const product = state.inventoryPOS.products.find(
          (item) =>
            item.sku === updatedProduct.sku &&
            item.inventories?.inventoryId === updatedProduct.inventoryId,
        );

        if (!product) {
          return;
        }

        // New sale events carry committed stock values. Ignore duplicates and
        // older events; retain delta handling for the existing mobile events.
        const stock = product.inventories.stock;
        if (Number.isFinite(updatedProduct.stockQuantity)) {
          if (Number.isFinite(updatedProduct.stockRevision) &&
              updatedProduct.stockRevision <= (stock.revision || 0)) return;
          stock.quantity = updatedProduct.stockQuantity;
          if (Number.isFinite(updatedProduct.stockRevision)) stock.revision = updatedProduct.stockRevision;
        } else if (updatedProduct.soldQuantity !== undefined) {
          stock.quantity -= updatedProduct.soldQuantity;
        }
        if (product.reports) {
          product.reports.total_quantity_sold = Number.isFinite(updatedProduct.totalQuantitySold)
            ? updatedProduct.totalQuantitySold
            : (product.reports.total_quantity_sold || 0) + (updatedProduct.soldQuantity || 0);
          if (Number.isFinite(updatedProduct.totalEarned)) product.reports.total_earned = updatedProduct.totalEarned;
        }
      });
    },
    terminalAction: (state, action) => {
      const { itemsPayload, registerData } = action.payload;
      state.registerData = registerData;
      state.registerClosure = null;
      state.inventoryPOS.products = itemsPayload;
      state.isAuthenticated = true;
    },
    switchView: (state, action) => {
      state.switchTerminalView = action.payload;
    },
    addtoCart: (state, action) => {
      if (!state.inventoryPOS) state.inventoryPOS = { cart: [], products: [] };
      if (!state.inventoryPOS.cart) state.inventoryPOS.cart = [];
      state.inventoryPOS.cart.unshift(action.payload.intoCart);
      state.inventoryPOS.sales_reciept = action.payload.recieptNo;
      state.inventoryPOS.contentType = action.payload.contentType;
    },
    onHoldPayload: (state, action) => {
      const prospondData = action.payload;
      if (!state.on_holded_sales) state.on_holded_sales = [];
      state.on_holded_sales.unshift(prospondData);
    },
    dispatchDiscount: (state, action) => {
      const discountData = action.payload;
      state.inventoryPOS.discount = discountData;
    },
    addShippingDispatch: (state, action) => {
      const { payloadShipping } = action.payload;
      state.inventoryPOS.shipping = payloadShipping;
    },
    updateSwitchPackage: (state, action) => {
      const { index, pkg } = action.payload;

      if (!state.inventoryPOS) state.inventoryPOS = { cart: [], products: [] };
      if (!state.inventoryPOS.cart) state.inventoryPOS.cart = [];

      if (state.inventoryPOS.cart[index]) {
        state.inventoryPOS.cart[index].soldQuantity = pkg;
      }
    },
    updateQuantity: (state, action) => {
      const { index, qty } = action.payload;

      if (!state.inventoryPOS) state.inventoryPOS = { cart: [], products: [] };
      if (!state.inventoryPOS.cart) state.inventoryPOS.cart = [];

      if (state.inventoryPOS.cart) {
        state.inventoryPOS.cart[index].soldQuantity = qty;
      }
    },
    insertQuantity: (state, action) => {
      const { index, qty } = action.payload;

      if (!state.inventoryPOS) state.inventoryPOS = { cart: [], products: [] };
      if (!state.inventoryPOS.cart) state.inventoryPOS.cart = [];

      if (state.inventoryPOS.cart) {
        state.inventoryPOS.cart[index].soldQuantity = qty;
      }
    },

    insertReturingQty: (state, action) => {
      const { index, qty } = action.payload;

      if (!state.acceptReturn) state.acceptReturn = {};

      if (state.acceptReturn) {
        state.acceptReturn.soldItems[index].returningQuantity = qty;
      }
    },
    updateReturingQty: (state, action) => {
      const { index, qty } = action.payload;
      if (!state.acceptReturn) state.acceptReturn = {};

      if (state.acceptReturn) {
        state.acceptReturn.soldItems[index].returningQuantity = qty;
      }
    },
    assignItemtoReturn: (state, action) => {
      const { index, assigned } = action.payload;
      state.acceptReturn.soldItems[index].assigned = assigned;
    },
    assignAllItemtoReturn: (state, action) => {
      const { index, assigned } = action.payload;
      state.acceptReturn.soldItems.map(
        (item, index) => (item.assigned = assigned),
      );
    },

    removeFromCart: (state, action) => {
      const index = action.payload;

      if (
        state.inventoryPOS &&
        Array.isArray(state.inventoryPOS.cart) &&
        index >= 0
      ) {
        state.inventoryPOS.cart.splice(index, 1);
      }
    },

    deleteOnholdDispatch: (state, action) => {
      const saleId = action.payload;

      if (Array.isArray(state.on_holded_sales)) {
        const index = state.on_holded_sales.findIndex(
          (item) => item.saleId === saleId,
        );

        if (index !== -1) {
          state.on_holded_sales.splice(index, 1);
        }
      }
    },

    clearCartAction: (state) => {
      state.inventoryPOS.cart = [];
      state.inventoryPOS.discount = {};
      state.inventoryPOS.shipping = {};
      state.inventoryPOS.sales_reciept = "";
      state.inventoryPOS.contentType = "";
    },
    clearOnholdedTransactions: (state) => {
      state.on_holded_sales = [];
    },
    clearProductsAction: (state) => {
      state.inventoryPOS.products = [];
    },
    beginRegisterClosure: (state, action) => {
      const request = action.payload;
      if (!state.isAuthenticated || state.inventoryPOS.cart.length || state.on_holded_sales.length ||
          request?.clientId !== state.registerData.clientId || request?.payload?.registerId !== state.registerData.registerId ||
          request?.payload?.inventoryId !== state.registerData.inventory?.inventoryId) return;
      if (!state.registerClosure) state.registerClosure = request;
    },
    cancelRegisterClosure: (state, action) => {
      if (state.registerClosure?.requestId === action.payload) state.registerClosure = null;
    },
    requireRegisterLogin: (state) => {
      if (state.registerClosure) return;
      state.isAuthenticated = false;
      state.registerData.requiresLogin = true;
    },
    dispatchCloseRegister: (state, action) => {
      const record = action.payload;
      if (record?.status !== "closed" || record.clientId !== state.registerData.clientId ||
          record.registerId !== state.registerData.registerId || record.inventoryId !== state.registerData.inventory?.inventoryId ||
          state.inventoryPOS.cart.length || state.on_holded_sales.length) return;
      state.lastRegisterClosure = record;
      state.registerClosure = null;
      state.registerData = {};
      state.isAuthenticated = false;
      state.inventoryPOS.cart = [];
      state.on_holded_sales = [];
      state.inventoryPOS.products = [];
      state.inventoryPOS.sales_reciept = "";
      state.inventoryPOS.contentType = "";
      state.inventoryPOS.discount = {};
      state.inventoryPOS.shipping = {};
      state.switchTerminalView = false;
      state.itemsSoldCount = 0;
      state.acceptReturn = {};
    },
    attendOnhold: (state, action) => {
      const { buyings, saleId, contentType } = action.payload;
      if (!state.inventoryPOS) state.inventoryPOS = { cart: [], products: [] };
      if (!state.inventoryPOS.cart) state.inventoryPOS.cart = [];
      state.inventoryPOS.cart = buyings;
      state.inventoryPOS.sales_reciept = saleId;
      state.inventoryPOS.contentType = "ON_HOLD_TRANSACTION";
    },
    onlogOutTerminalAction: (state) => {
      state.isAuthenticated = false;
      state.switchTerminalView = false;
      state.registerData = {};
      state.registerClosure = null;
      state.lastRegisterClosure = null;
      state.on_holded_sales = [];
      state.inventoryPOS = {
        contentType: "",
        sales_reciept: "",
        cart: [],
        products: [],
        customers: [],
        brands: [],
        discount: {},
        shipping: {},
      };
      state.itemsSoldCount = 0;
      state.acceptReturn = {};
    },
    dispatchAcceptReturnData: (state, action) => {
      state.acceptReturn = action.payload;
    },
  },
});

export const {
  updateProductsFromSocket,
  terminalAction,
  switchView,
  addtoCart,
  updateSwitchPackage,
  updateQuantity,
  removeFromCart,
  clearCartAction,
  clearProductsAction,
  clearOnholdedTransactions,
  insertQuantity,
  onHoldPayload,
  attendOnhold,
  addShippingDispatch,
  deleteOnholdDispatch,
  dispatchCloseRegister,
  beginRegisterClosure,
  cancelRegisterClosure,
  requireRegisterLogin,
  dispatchDiscount,
  onlogOutTerminalAction,
  dispatchAcceptReturnData,
  assignItemtoReturn,
  assignAllItemtoReturn,
  insertReturingQty,
  updateReturingQty,
} = terminalReducer.actions;

export default terminalReducer.reducer;
